function csvText(value) {
  if (Array.isArray(value)) return value.map(csvText).filter(Boolean).join(" · ");
  if (value && typeof value === "object") {
    return value.nombre || value.label || value.title || "";
  }
  return value === null || value === undefined ? "" : String(value);
}

function csvCell(value) {
  const text = csvText(value);
  const safeText = /^\s*[=+\-@]/.test(text) ? `'${text}` : text;
  return `"${safeText.replace(/"/g, '""')}"`;
}

export function downloadPageCsv(columns, rows, hiddenColumns, filename) {
  const visibleColumns = columns.filter(
    (column) =>
      !hiddenColumns.includes(column.name) &&
      column.options?.download !== false &&
      column.options?.display !== "excluded" &&
      column.options?.display !== false
  );
  if (!visibleColumns.length || !rows.length) return;

  const csv = [
    visibleColumns.map((column) => csvCell(column.label)).join(","),
    ...rows.map((row) =>
      visibleColumns.map((column) => csvCell(row[column.name])).join(",")
    ),
  ].join("\r\n");
  const file = new Blob(["\uFEFF", csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(file);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 0);
}
